interface RelinquishHexModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    hexName: string;
    isRelinquishing: boolean;
}

export function RelinquishHexModal({
    isOpen,
    onClose,
    onConfirm,
    hexName,
    isRelinquishing,
}: RelinquishHexModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-slate-800 rounded-lg p-6 w-full max-w-md border border-slate-700">
                <h3 className="text-lg font-semibold text-white mb-4">Relinquish Hex?</h3>
                <div className="mb-6">
                    <p className="text-gray-300 mb-3">
                        Are you sure you want to relinquish <strong className="text-white">{hexName}</strong>?
                    </p>
                    <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-3 text-sm text-red-200">
                        <p className="font-semibold mb-1">Warning: This action cannot be undone!</p>
                        <ul className="list-disc list-inside space-y-1 text-red-300">
                            <li>All pages and content will be deleted</li>
                            <li>You will lose ownership of this hex</li>
                            <li>The hex will become available for others to claim</li>
                        </ul>
                    </div>
                </div>
                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isRelinquishing}
                        className="px-4 py-2 text-gray-300 hover:text-white transition-colors disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isRelinquishing}
                        className="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:bg-red-800 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
                    >
                        {isRelinquishing ? 'Relinquishing...' : 'Yes, Relinquish Hex'}
                    </button>
                </div>
            </div>
        </div>
    );
}
